/**
 * @generated SignedSource<<ab2cb44cdc12a6dac5aa96ad7c3240e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type hierarchyToggle_issueNavigator_HierarchyToggleItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHierarchyToggle_HierarchyToggle">;
  readonly " $fragmentType": "hierarchyToggle_issueNavigator_HierarchyToggleItem";
};
export type hierarchyToggle_issueNavigator_HierarchyToggleItem$key = {
  readonly " $data"?: hierarchyToggle_issueNavigator_HierarchyToggleItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"hierarchyToggle_issueNavigator_HierarchyToggleItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueTableHierarchyToggle_HierarchyToggle"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "8e796238c1074f1745096a3c917924c8";

export default node;
